// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'authErrorModal.errorHeader': 'Maximum Login Attempts Reached',
  'authErrorModal.supportBody': "If you're having issues please call ",
};
